module.exports = __webpack_public_path__ + "static/media/preStall.db8d5595.png";